import React from 'react';

import type { IconProps } from '../../Icon';
import type { ButtonProps } from '../Button.types';
import { checkedInverseViews, contrastViews } from '../constants';

export type UseIconButtonProps = Pick<ButtonProps, 'children' | 'view' | 'isDisabled' | 'icon'> & {
    isChecked?: boolean;
};

export const useIconButton = (props: UseIconButtonProps) => {
    const { view, isDisabled, isChecked, children, icon } = props;

    const isContrastView = React.useMemo(
        () => view && (contrastViews.has(view) || (isChecked && checkedInverseViews.has(view))),
        [view, isChecked],
    );

    const iconColor = React.useMemo<IconProps['color']>(() => {
        if (isDisabled) {
            return 'tertiary';
        }
        return isContrastView ? undefined : 'secondary';
    }, [isDisabled, isContrastView]);

    const isIconButton = React.useMemo(
        () => Boolean(icon) && (!children || children === 0),
        [children, icon],
    );

    return { isIconButton, iconColor };
};
